export class ConstantsRouting {
    static readonly DEFINITION_UND_ANWENDUNGSBEREICH: string = "definition-und-anwendungsbereich"; 
    static readonly PSEUDONYMISIERUNG_CODE: string = "pseudonymisierung-code";
    static readonly PSEUDONYMISIERUNG_VERFAHREN: string = "pseudonymisierung-verfahren"; 

}
  

   